const homeworkStatus = {
  0: {
    "title": "未完成",
    "icon": null
  },
  1: {
    "title": "部分完成",
    "icon": null
  },
  2: {
    "title": "已完成",
    "icon": "anyteachicon anyteach-success"
  },
}

export {
  homeworkStatus
}